

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function(e) {

    //category click handler
    if(e.target.classList.contains('js-posts-category')) {

      const currentCategoryElement = document.querySelector('.js-posts-category.active');
      let newCategory = '';
      let url = new URL(window.location.href);
      let params = new URLSearchParams();

      //if the same category is active
      if (currentCategoryElement && currentCategoryElement === e.target) {
        newCategory = 'all';
        e.target.classList.remove('active');
      }
      //if another category is active
      else if (currentCategoryElement) {
        newCategory = e.target.dataset.category;
        currentCategoryElement.classList.remove('active');
        e.target.classList.add('active');
        params.set('category', newCategory);
      }
      //if no category is active
      else {
        newCategory = e.target.dataset.category;
        e.target.classList.add('active');
        params.set('category', newCategory);
      }

      url.search = params.toString();
      history.pushState({}, "", url);

      const formData = new FormData();
      formData.append("action", "posts_by_category");
      formData.append("category", newCategory);

      fetch(themeVars.ajax_url, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          throw new Error("Failed to fetch data");
        }
      })
      .then((response) => {
        const postsContent = document.querySelector('.js-posts-wrapper');
        postsContent.innerHTML = response;
        aosReinit();
      })
      .catch((error) => {
        console.error(error);
      });
    }

    //load more click handler
    if(e.target.classList.contains('js-load-more-posts')) {
      const category = e.target.dataset.category;
      const currentPage = parseInt(e.target.dataset.currentPage);
      const maxPages = parseInt(e.target.dataset.maxPage);

      if (currentPage >= maxPages) {
        return;
      }

      const newPage = currentPage + 1;

      const formData = new FormData();
      formData.append("action", "load_more_posts");
      formData.append("category", category);
      formData.append("page", newPage);

      fetch(themeVars.ajax_url, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          throw new Error("Failed to fetch data");
        }
      })
      .then((response) => {
        const blogContent = document.querySelector(".js-posts-list");
        blogContent.insertAdjacentHTML('beforeend', response);
        aosReinit();

        if (newPage == maxPages) {
          e.target.remove();
        }
        else {
          e.target.dataset.currentPage = newPage;
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }

    if(e.target.classList.contains('js-post-card-category')) {
      e.stopPropagation();
      e.preventDefault();
      const link = e.target.dataset.href;
      window.open(link, "_self");
    }
  });

  function aosReinit(){
    const elements = [...document.querySelectorAll('[data-aos]')];

    function addAnimatedClass() {
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        ) {
          el.classList.add('aos-animate');
        }
      });
    }

    addAnimatedClass();

    window.lenis.on('scroll', addAnimatedClass);
  }
})
